import * as React from "react";
import { Card, Tabs, Tab } from "react-bootstrap";
import "../../css/AdviceJoke.css";

interface IState {
  advice: string;
  joke: string;
}
export default class RandomAdvice extends React.PureComponent<{}, IState> {
  componentDidMount() {
    this.fetchAdvice();
  }

  fetchAdvice = () => {
    let adviceurl = "https://api.adviceslip.com/advice";
    (async () => {
      let response = await fetch(adviceurl);
      let advice = await response.json();
      this.setState({ advice: advice.slip.advice });
    })();

    /*let jokeUrl = "https://api.chucknorris.io/jokes/random";
   "animal","career","celebrity","dev","explicit","fashion","food","history",
   "money","movie","music","political","religion","science","sport","travel"
   */
    let jokeUrl = "https://api.chucknorris.io/jokes/random?name=Max&category=travel,sport,animal,fashion,history,money,movie,music,career,food,science,celebrity,dev";
    (async () => {
      let response = await fetch(jokeUrl);
      let joke = await response.json();
      this.setState({ joke: joke.value });
    })();
  };

  render() {
    return (
      <div>
        <br />
        <h1>Here We go...!</h1>
        <Card className="adJokeCard">
          <Card.Body>
            <Tabs
              defaultActiveKey="Joke"
              id="uncontrolled-tab-example"
              className="bold"
            >
              <Tab eventKey="Joke" title="Joke" className="adJoke">
                {this.state && this.state.joke}
                <i
                  className="fas fa-smile"
                  style={{ color: "goldenrod", fontSize: "1.5em" }}
                ></i>
              </Tab>
              <Tab eventKey="Advice" title="Advice" className="adJoke">
                {this.state && this.state.advice}
                <i
                  className="fas fa-smile-wink"
                  style={{ color: "goldenrod", fontSize: "1.5em" }}
                ></i>
              </Tab>
            </Tabs>
          </Card.Body>
        </Card>
        <br />
        <strong>
          Source & Thanks to :
          <a href="https://api.chucknorris.io/#!">chucknorris.io</a> &nbsp;
          <a href=" https://api.adviceslip.com/advice">api.adviceslip.com</a>
        </strong>
      </div>
    );
  }
}
